import { Component, OnInit } from '@angular/core';
import { combineLatest } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CurrenciesService } from 'src/app/api/currencies.service';
import { MetadataService } from 'src/app/api/metadata.service';
import { Currency } from 'src/app/models/currency';
import { ChatService } from 'src/app/services/chat.service';
import { MobileWebViewService } from 'src/app/services/mobile-web-view.service';

interface CurrencyWithLink extends Currency {
  link?: string;
}
@Component({
  selector: 'supported-tokens',
  templateUrl: './supported-tokens.component.html',
  styleUrls: ['./supported-tokens.component.scss']
})
export class SupportedTokensComponent implements OnInit {
  loading = true;
  error: string = null;

  searchValue: string;
  cryptos: CurrencyWithLink[];
  filteredCryptos: CurrencyWithLink[];
  fiatCurrency: string;

  isMobileWebView$ = this.mobileWebViewService.isMobileWebView$;

  constructor(
    private metadata: MetadataService,
    private currenciesService: CurrenciesService,
    private mobileWebViewService: MobileWebViewService,
  ) { }

  async ngOnInit() {
    await this.getDefaultFiatCurrency();
    this.getCryptoCurrencies();
  }

  getDefaultFiatCurrency() {
    return this.metadata.userCurrency().pipe(
      tap(response => {
        this.fiatCurrency = response;
      }, () => {
        this.fiatCurrency = environment.currencies.defaultCurrency;
      })
    ).toPromise();
  }

  getCryptoCurrencies() {
    this.loading = true;
    combineLatest([this.currenciesService.getCrypto(), this.mobileWebViewService.isMobileWebView$])
    .pipe(take(1))
    .subscribe(([response, isMobileWebView]) => {
      this.cryptos = isMobileWebView ? response : this.updateCryptosWithLink(response);
      this.filteredCryptos = this.cryptos;
      this.loading = false;
    }, err => {
      this.loading = false;
      this.error = err.errors[0].message;
    });
  }

  updateCryptosWithLink(currencies: Currency[]): CurrencyWithLink[] {
    return currencies?.map(crypto => {
      const item: CurrencyWithLink = crypto;
      item.link = item?.acceptedPairs?.find(pair => pair.endsWith(this.fiatCurrency)) || item?.acceptedPairs?.[0];
      return item;
    });
  }

  filterData({ filteredItems, searchValue }) {
    this.filteredCryptos = filteredItems;
    this.searchValue = searchValue;
  }

  clearSearchValue() {
    this.searchValue = '';
  }
}
